import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientRegisterTableAndFilterSchema } from "model/ClientRegisterModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientRegisterContext = createContext();

export const ClientRegisterProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientRegisterContextData, setClientRegisterContextData] = useState();

  const fetchClientRegisterContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientRegister", () =>
        fetchClientRegisterTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientRegisterContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client register metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientRegisterContext.Provider
      value={{
        fetchClientRegisterContextData,
        clientRegisterContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientRegisterContext.Provider>
  );
};

export const useClientRegisterContext = () => useContext(ClientRegisterContext);
